import { http } from 'utils'
import { make } from 'vuex-pathify'

export default {
  namespaced: true,

  state: {
    drivers: []
  },

  actions: {
    ...make.actions('drivers'),

    async getDrivers ({ dispatch }) {
      const response = await http.get('drivers')

      dispatch('setDrivers', response.data.data)

      return response
    }
  },

  mutations: {
    ...make.mutations('drivers')
  }
}
